import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection, $getRoot, $createParagraphNode } from 'lexical'
import { INSERT_SELECT } from '../commands'
import { SelectNode } from '../nodes/selectNode'

export function InsertSelectPlugin({ insertRef }) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const unregister = mergeRegister(
      editor.registerCommand(INSERT_SELECT, props => {
        editor.update(() => {
          const node = new SelectNode(props)
          const selection = $getSelection()
          if ($isRangeSelection(selection)) {
            selection.insertNodes([node])
          } else {
            const root = $getRoot()
            let para = root.getLastChild()
            if (!para || para.getType() !== 'paragraph') {
              para = $createParagraphNode()
              root.append(para)
            }
            para.append(node)
          }
        })
        return true
      }, 0)
    )

    insertRef.current.insertSelect = props => editor.dispatchCommand(INSERT_SELECT, props)
    insertRef.current.editor = editor

    return () => unregister()
  }, [editor, insertRef])

  return null
}
